import React from 'react'
import { saveAs } from 'file-saver'

import { Container, SubMenu } from './style'
import { MenuLink, TitleMenu } from '../../style'

import postmanIco from '../../../../assets/postman.png'
import apiBoxCollection from '../json-collections/api-box-collection.json'
import skypostalCollectionJson from '../json-collections/skypostalCollection.json'

class Menu extends React.Component {
  state = {
    routes: this.props.routes.map(route => {
      route.content.map(content => {
        content.active = false
        return content
      })
      return route
    })
  }

  handleIsOpenChange = index => {
    const { routes } = this.state

    this.setState({
      routes: routes.map(route => {
        route.content[index].active = true
        return route
      })
    })
  }

  sayHelloApiBox = () => {
    const skypostalCollectionApiBox = {
      ...apiBoxCollection
    }
    const myJSON = JSON.stringify(skypostalCollectionApiBox)
    const blob = new Blob([myJSON], {
      type: 'application/json;charset=utf-8'
    })
    saveAs(blob, 'skypostal-api-box.postman_collection.json')
  }

  sayHello = () => {
    const skypostalCollection = { ...skypostalCollectionJson }

    const myJSON = JSON.stringify(skypostalCollection)

    const blob = new Blob([myJSON], {
      type: 'application/json;charset=utf-8'
    })
    saveAs(blob, 'SKYPOSTAL_2.0_.postman_collection.json')
  }

  render() {
    const { routes } = this.state

    return (
      <Container>
        {routes.map(route => {
          let routeApi = route.api

          if (route.api.match(/1.0/g)) {
            routeApi = routeApi.replace(/1.0/gi, '')
          }

          if (route.api.match(/2.0/g)) {
            routeApi = routeApi.replace(/2.0/gi, '')
          }

          return (
            <div key={route.pathname}>
              <MenuLink
                activeStyle={{
                  color: 'white'
                }}
                style={{ color: 'white' }}
                to={route.pathname}
                state={{ routes }}
              >
                {routeApi}
                {route.api.match(/1.0/g) && (
                  <small style={{ fontSize: '10px', color: 'white' }}>
                    1.0
                  </small>
                )}
                {route.api.match(/2.0/g) && (
                  <small style={{ fontSize: '10px', color: 'white' }}>
                    2.0
                  </small>
                )}
              </MenuLink>
              <>
                {route.content.map((content, index) => {
                  return (
                    <div key={content.parent}>
                      <TitleMenu onClick={() => this.handleIsOpenChange(index)}>
                        {content.parent}
                      </TitleMenu>
                      {content.children &&
                        content.children.map(child => {
                          return (
                            <SubMenu
                              key={child.name}
                              isOpen={content.active && !child.children}
                            >
                              {!child.children ? (
                                <MenuLink
                                  activeStyle={{
                                    color: 'white'
                                  }}
                                  to={
                                    route.pathname +
                                    content.pathname +
                                    child.pathname
                                  }
                                  state={{ routes }}
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {child.name}
                                </MenuLink>
                              ) : (
                                <TitleMenu>{child.name}</TitleMenu>
                              )}

                              {child.children &&
                                child.children.map(secondChildren => {
                                  return (
                                    <SubMenu
                                      key={child.name}
                                      isOpen={content.active}
                                    >
                                      <MenuLink
                                        activeStyle={{
                                          color: 'white'
                                        }}
                                        to={
                                          route.pathname +
                                          content.pathname +
                                          child.pathname +
                                          secondChildren.pathname
                                        }
                                        state={{ routes }}
                                        style={{ whiteSpace: 'nowrap' }}
                                      >
                                        {secondChildren.name}
                                      </MenuLink>
                                    </SubMenu>
                                  )
                                })}
                            </SubMenu>
                          )
                        })}
                    </div>
                  )
                })}
              </>
              {route.api.match(/Customer 2.0/g) && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '4rem'
                  }}
                  onClick={this.sayHello}
                >
                  <img
                    src={postmanIco}
                    width={25}
                    style={{ marginRight: '5px' }}
                  />
                  <span style={{ color: 'white', cursor: 'pointer' }}>
                    Skypostal Collection
                  </span>
                </div>
              )}
              {route.api.match(/Box/g) && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '4rem'
                  }}
                  onClick={this.sayHelloApiBox}
                >
                  <img
                    src={postmanIco}
                    width={25}
                    style={{ marginRight: '5px' }}
                  />
                  <span style={{ color: 'white', cursor: 'pointer' }}>
                    API-BOX Collection
                  </span>
                </div>
              )}
            </div>
          )
        })}
      </Container>
    )
  }
}

export default Menu
